import React, { MouseEvent, MouseEventHandler, ReactNode } from "react"

interface Props {
  children?: ReactNode
  className?: string
  innerClassName?: string
  title?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

const LinkItem = ({
  children,
  className = "",
  innerClassName = "",
  title = "",
  onClick,
}: Props) => (
  <li className={className}>
    <a
      href="#!"
      className={innerClassName}
      title={title}
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault()
        onClick?.(e)
      }}
    >
      {children || title}
    </a>
  </li>
)

export default LinkItem
